import { render } from "./UserEdit.vue?vue&type=template&id=fc47ffb6&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"

import "./UserEdit.vue?vue&type=style&index=0&id=fc47ffb6&lang=scss&scoped=true"
import "./UserEdit.vue?vue&type=style&index=1&id=fc47ffb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc47ffb6"]])

export default __exports__